import { Segment } from '../../../../services/analytics-services/segment';
import { LABS_FEATURE_FEEDBACK_SUBMITTED } from '../../../../constants/analytics-events';
import { featureMessages } from '../labs-feature-messages';
/**
 * Custom hook for handling labs feature feedback
 * @returns {{saveFeedback: (params: import('../typedefs').FeedbackData) => void}} Feedback handler functions
 */
export const useLabsFeedback = () => {
  /**
   * Saves user feedback for a labs feature
   * @param {import('../typedefs').FeedbackData} params - Feedback data
   */
  const saveFeedback = ({ feature, feedbackText, isDisableMode }) => {
    Segment.trackEvent(LABS_FEATURE_FEEDBACK_SUBMITTED, {
      featureId: feature?.id,
      featureTitle: featureMessages[feature?.titleKey]?.defaultMessage || feature?.titleKey,
      featureCategory: feature?.category,
      feedback: feedbackText.trim(),
      isDisablingFeature: isDisableMode,
    });
  };

  return { saveFeedback };
};
